// import { useGetCategoryQuery } from "../../features/category/categoryApiSlice";
import { useGetAvailableChapelQuery } from "../../features/chapel/chapelApiSlice";
import { useGetClientQuery } from "../../features/client/clientApiSlice";
import { useGetRolesQuery, useGetStatusQuery } from "../../features/masterData/masterDataApiSlice"
import { useGetAllOrderQuery } from "../../features/order/orderApiSlice";
import { useGetAllPackageQuery, useGetDefaultPackagesQuery, useGetSpecialPackagesQuery } from "../../features/package/packageApiSlice";
import { useGetAllProductQuery } from "../../features/product/productApiSlice";
import { useGetAddOnsQuery, useGetCategoryQuery, useGetSizesQuery, useGetTemperaturesQuery } from "../../features/setup/setupApiSlice";
import { useGetAllUsersStaffQuery } from "../../features/user/usersApiSlice";
import { getRtkErrorMessage } from "../../utils/getRtkErrorMessage";

export const useMasterData = () => {
    // without polling
    const { data: roles = [], isFetching: isFetchingRoles, isLoading: isLoadingRoles, isError: isErrorRoles, refetch: refetchRoles, error: errorRoles } = useGetRolesQuery()
    // const { data: products = [], isFetching: isFetchingProducts, isLoading: isLoadingProducts, isError: isErrorProducts, refetch: refetchProducts, error: errorProducts } = useGetAllProductQuery()
    const { data: status = [], isFetching: isFetchingStatus, isLoading: isLoadingStatus, isError: isErrorStatus, refetch: refetchStatus, error: errorStatus } = useGetStatusQuery()
    const { data: getBasicPackage, isFetching: isFetchingGetBasicPackage, isLoading: isLoadingGetBasicPackage, isError: isErrorGetBasicPackage, refetch: refetchGetBasicPackage, error: errorGetBasicPackage } = useGetDefaultPackagesQuery()
    const { data: getAllProduct, isFetching: isFetchingGetAllProduct, isLoading: isLoadingGetAllProduct, isError: isErrorGetAllProduct, refetch: refetchGetAllProduct, error: errorGetAllProduct } = useGetAllProductQuery()
    const { data: getSizes = [], isFetching: isFetchingGetSizes, isLoading: isLoadingGetSizes, isError: isErrorGetSizes, refetch: refetchGetSizes, error: errorGetSizes } = useGetSizesQuery()
    const { data: addOns = [], isFetching: isFetchingAddOns, isLoading: isLoadingAddOns, isError: isErrorAddOns, refetch: refetchAddOns, error: errorAddOns } = useGetAddOnsQuery()
    const { data: productTemperature = [], isFetching: isFetchingProductTemperature, isLoading: isLoadingProductTemperature, isError: isErrorProductTemperature, refetch: refetchProductTemperature, error: errorProductTemperature } = useGetTemperaturesQuery()
    const { data: getSpecialPackages = [], isFetching: isFetchingGetSpecialPackages, isLoading: isLoadingGetSpecialPackages, isError: isErrorGetSpecialPackages, refetch: refetchGetSpecialPackages, error: errorGetSpecialPackages } = useGetSpecialPackagesQuery()
    
    const errorMessageRoles = getRtkErrorMessage(errorRoles);
    // const errorMessageProducts = getRtkErrorMessage(errorProducts);
    const errorMessageStatus = getRtkErrorMessage(errorStatus);
    const errorMessageGetBasicPackage = getRtkErrorMessage(errorGetBasicPackage);
    const errorMessageGetAllProduct = getRtkErrorMessage(errorGetAllProduct);
    const errorMessageGetSizes = getRtkErrorMessage(errorGetSizes);
    const errorMessageAddOns = getRtkErrorMessage(errorAddOns);
    const errorMessageProductTemperature = getRtkErrorMessage(errorProductTemperature);
    const errorMessageSpecialPackages = getRtkErrorMessage(errorGetSpecialPackages);

    // with polling
    // const { data: usersData = [], isError: isErrorUsersData, isLoading: isLoadingUsersData, isFetching: isFetchingUsersData, refetch: refetchUsersData, error: errorUsersData } = useGetAllUsersStaffQuery(undefined, {pollingInterval: 1000,});
    // const { data: orders = [], isError: isErrorOrders, isLoading: isLoadingOrders, isFetching: isFetchingOrders, refetch: refetchOrders, error: errorOrders } = useGetAllOrderQuery(undefined, {pollingInterval: 1000,});
    // const { data: clients = [], isError: isErrorClients, isLoading: isLoadingClients, isFetching: isFetchingClients, refetch: refetchClients, error: errorClients } = useGetClientQuery(undefined, {pollingInterval: 1000,});
    // const { data: allPackages = [], isError: isErrorAllPackages, isLoading: isLoadingAllPackages, isFetching: isFetchingAllPackages, refetch: refetchAllPackages, error: errorAllPackages } = useGetAllPackageQuery(undefined, {pollingInterval: 1000,});
    // const { data: chapelsAvailable = [], isError: isErrorChapelsAvailable, isLoading: isLoadingChapelsAvailable, isFetching: isFetchingChapelsAvailable, refetch: refetchChapelsAvailable, error: errorChapelsAvailable, isSuccess: isSuccessChapelsAvailable } = useGetAvailableChapelQuery(undefined, {pollingInterval: 1000,});
    // const { data: getCategory = [], isError: isErrorGetCategory, isLoading: isLoadingGetCategory, isFetching: isFetchingGetCategory, refetch: refetchGetCategory, error: errorGetCategory } = useGetCategoryQuery(undefined, {pollingInterval: 1000,});
    
    const { data: usersData = [], isError: isErrorUsersData, isLoading: isLoadingUsersData, isFetching: isFetchingUsersData, refetch: refetchUsersData, error: errorUsersData } = useGetAllUsersStaffQuery();
    const { data: orders = [], isError: isErrorOrders, isLoading: isLoadingOrders, isFetching: isFetchingOrders, refetch: refetchOrders, error: errorOrders } = useGetAllOrderQuery();
    const { data: clients = [], isError: isErrorClients, isLoading: isLoadingClients, isFetching: isFetchingClients, refetch: refetchClients, error: errorClients } = useGetClientQuery();
    // const { data: allPackages = [], isError: isErrorAllPackages, isLoading: isLoadingAllPackages, isFetching: isFetchingAllPackages, refetch: refetchAllPackages, error: errorAllPackages } = useGetAllPackageQuery();
    const { data: allPackages, isError: isErrorAllPackages, isLoading: isLoadingAllPackages, isFetching: isFetchingAllPackages, refetch: refetchAllPackages, error: errorAllPackages } = useGetAllPackageQuery();
    const { data: chapelsAvailable = [], isError: isErrorChapelsAvailable, isLoading: isLoadingChapelsAvailable, isFetching: isFetchingChapelsAvailable, refetch: refetchChapelsAvailable, error: errorChapelsAvailable, isSuccess: isSuccessChapelsAvailable } = useGetAvailableChapelQuery();
    const { data: getCategory = [], isError: isErrorGetCategory, isLoading: isLoadingGetCategory, isFetching: isFetchingGetCategory, refetch: refetchGetCategory, error: errorGetCategory } = useGetCategoryQuery();
    const { data: allChapels = [], isError: isErrorAllChapels, isLoading: isLoadingAllChapels, isFetching: isFetchingAllChapels, refetch: refetchAllChapels, error: errorAllChapels } = useGetAvailableChapelQuery();

    const errorMessageUserData = getRtkErrorMessage(errorUsersData);
    const errorMessageOrders = getRtkErrorMessage(errorOrders);
    const errorMessageClients = getRtkErrorMessage(errorClients);
    const errorMessageAllPackages = getRtkErrorMessage(errorAllPackages);
    const errorMessageChapelsAvailable = getRtkErrorMessage(errorChapelsAvailable);
    const errorMessageGetCategory = getRtkErrorMessage(errorGetCategory);
    const errorMessageAllChapels = getRtkErrorMessage(errorAllChapels);
    
    return {
        // roles API
        roles,
        isFetchingRoles,
        isLoadingRoles,
        refetchRoles,
        isErrorRoles,
        errorMessageRoles,
        // // products API
        // products,
        // isFetchingProducts,
        // isLoadingProducts,
        // refetchProducts,
        // isErrorProducts,
        // errorMessageProducts,
        // status API
        status,
        isErrorStatus,
        isFetchingStatus,
        isLoadingStatus,
        refetchStatus,
        errorMessageStatus,
        // user data/list API
        usersData,
        isErrorUsersData,
        isLoadingUsersData,
        isFetchingUsersData,
        refetchUsersData,
        errorMessageUserData,
        // orders API
        orders,
        isErrorOrders,
        isLoadingOrders,
        refetchOrders,
        isFetchingOrders,
        errorMessageOrders,
        // client API
        clients,
        isErrorClients,
        isLoadingClients,
        isFetchingClients,
        refetchClients,
        errorMessageClients,
        // get basic/default package
        getBasicPackage,
        isFetchingGetBasicPackage,
        isLoadingGetBasicPackage,
        refetchGetBasicPackage,
        isErrorGetBasicPackage,
        errorMessageGetBasicPackage,
        // all products API
        getAllProduct,
        isFetchingGetAllProduct,
        isLoadingGetAllProduct,
        refetchGetAllProduct,
        isErrorGetAllProduct,
        errorMessageGetAllProduct,
        // all packages API
        allPackages,
        isErrorAllPackages,
        isLoadingAllPackages,
        isFetchingAllPackages,
        refetchAllPackages,
        errorMessageAllPackages,
        // chapels available API
        chapelsAvailable,
        isErrorChapelsAvailable,
        isLoadingChapelsAvailable,
        isFetchingChapelsAvailable,
        refetchChapelsAvailable,
        errorMessageChapelsAvailable,
        isSuccessChapelsAvailable,
        // get category API
        getCategory,
        isErrorGetCategory,
        isLoadingGetCategory,
        isFetchingGetCategory,
        refetchGetCategory,
        errorMessageGetCategory,
        errorGetCategory,
        // get sizes
        getSizes,
        isFetchingGetSizes,
        isLoadingGetSizes,
        refetchGetSizes,
        isErrorGetSizes,
        errorMessageGetSizes,
        errorGetSizes,

        addOns,
        isFetchingAddOns,
        isLoadingAddOns,
        refetchAddOns,
        isErrorAddOns,
        errorMessageAddOns,
        errorAddOns,

        productTemperature,
        isFetchingProductTemperature,
        isLoadingProductTemperature,
        refetchProductTemperature,
        isErrorProductTemperature,
        errorMessageProductTemperature,
        errorProductTemperature,

        getSpecialPackages,
        isFetchingGetSpecialPackages,
        isLoadingGetSpecialPackages,
        refetchGetSpecialPackages,
        isErrorGetSpecialPackages,
        errorMessageSpecialPackages,
        errorGetSpecialPackages,

        allChapels,
        isFetchingAllChapels,
        isLoadingAllChapels,
        refetchAllChapels,
        isErrorAllChapels,
        errorMessageAllChapels,
        errorAllChapels,
    }
}